import {z} from 'zod';
import {zodTypeguard} from '../api/helpers';
import {ObjectIdSchema} from '../zod';

export const IntegrationTypeSchema = z.enum([
  'linkedin',
  'hubspot',
  'salesforce',
  'slack',
  'webIntent',
]);

export type IntegrationType = z.infer<typeof IntegrationTypeSchema>;
export const isIntegrationType = zodTypeguard(IntegrationTypeSchema);

export const IntegrationStatusSchema = z.enum([
  'active',
  'disconnected',
  'refresh_token_expired',
]);
export type IntegrationStatus = z.infer<typeof IntegrationStatusSchema>;

export const BaseIntegrationSchema = z.object({
  id: ObjectIdSchema,
  timestamp: z.date(),
  type: IntegrationTypeSchema,
  status: IntegrationStatusSchema,
});
